(function() {
    'use strict';

angular.module('app.modals.softwareUpdate', [])

    .controller('softwareUpdateModalCtrl', ['$scope', '$state', 'versions', 'close','__DatapointValue', 'xCenterConfig',
        function ($scope, $state, versions, close, __DatapointValue, xCenterConfig) {
            $scope.versions = versions;
            $scope.init = function() {
                var o = [
                    { // SoftwareUpdateStatus
                        'DatapointConfigId': '61afe142-5709-47f3-9624-511f6c96ec00',
                        'DeviceId': xCenterConfig.var.guid_Empty
                    },
                    {
                        'DatapointConfigId': "89ef4512-8b6d-4919-a8cb-7de72cbfb002",
                        'DeviceId': xCenterConfig.var.guid_Empty
                    },
                    {
                        'DatapointConfigId': xCenterConfig.datapointsString.System_SoftwareUpdateInfo,
                        'DeviceId': xCenterConfig.var.guid_Empty
                    }
                ];
                __DatapointValue.$collection(o).$refresh().$then(function(data){
                    switch(data[0].Value)
                    {
                        case 1:
                            $scope.StatusText = 'SYSTEM_SoftwareUpdate_NewVersionAvailable';
                            $scope.softwareVersionNew = true;
                            break;
                        default:
                            $scope.StatusText = 'SYSTEM_SoftwareUpdate_VersionUpToDate';
                            $scope.softwareVersionNew = false;
                    }
                    $scope.softwareVersion = data[1].Value;

                    if (data[2].Value.indexOf('Ver.: ') === 0) {
                        $scope.newSoftwareVersion = data[2].Value.slice(6);
                    } else {
                        $scope.newSoftwareVersion = data[2].Value;
                    }
                });
            };
            $scope.init();
            $scope.close = function () {
                close(500);
            };

            $scope.doSoftwareUpdate = function () {

                $state.go('softwareUpdate');
                close();
            };
        }
    ])

    .factory('softwareUpdateModal', ['ModalService', function (ModalService) {
        return function (versions) {
            ModalService.showModal({
                templateUrl: "views/modals/softwareUpdate.html",
                controller: 'softwareUpdateModalCtrl',
                inputs: {
                    versions: versions
                }
            });


        };
    }]);

})();
